var default_styles_default = {
  "button_container": "pUuhw",
  "button_margin": "tVa60",
  "button_text": "as2KK",
  "button_size_content": "TGRnc"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
